import { createContext } from 'react';

export interface AppShellContextValue {
  drawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const AppShellContext = createContext<AppShellContextValue | null>(null);
